// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_GenerateId from "../Restaumatic.Form.GenerateId/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_List from "../Specular.FRP.List/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Sortable_Utils from "../Specular.Sortable.Utils/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var LocalId = function (x) {
    return x;
};
var List = function (x) {
    return x;
};
var ListItem = function (x) {
    return x;
};
var isTextFieldListItem = function (dictIsTextField) {
    return {
        textInput: function (v) {
            return Restaumatic_Form.textInput(dictIsTextField)(v.subform);
        }
    };
};
var hasFieldIdList = {
    getFieldId: function (v) {
        return Restaumatic_Form.fieldPathToString(v.name);
    }
};
var hasFieldIdListItem = function (dictShow) {
    return {
        getFieldId: function (v) {
            return Restaumatic_Form.getFieldId(hasFieldIdList)(v.parent) + ("." + Data_Show.show(dictShow)(v.key));
        }
    };
};
var subform = function (v) {
    return v.subform;
};
var hasErrorsListItem = function (dictHasErrors) {
    return {
        displayedErrors: function (f) {
            return Restaumatic_Form.displayedErrors(dictHasErrors)(subform(f));
        }
    };
};
var showLocalId = Data_Show.showInt;
var queryOMapArrayList = function (dictQuery) {
    return {
        queryWith: function (strictness) {
            return function (v) {
                return Restaumatic_Form_Final.bindFinal(Restaumatic_Form_Final.liftDynamic(Specular_Ref.value(v.items)))(function (items1) {
                    return Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Array.catMaybes)(Data_Traversable["for"](Restaumatic_Form_Final.applicativeFinal)(Data_Traversable.traversableArray)(items1)(function (v1) {
                        return Restaumatic_Form_Final.bindFinal(Restaumatic_Form_Final.liftDynamic(Specular_Ref.value(v1.presentWhen)))(function (presentF) {
                            return Restaumatic_Form_Final.bindFinal(Restaumatic_Form.queryWith(Restaumatic_Form.queryFinal(Type_Equality.refl))(strictness)(presentF))(function (present) {
                                if (present) {
                                    return Data_Functor.map(Restaumatic_Form_Final.functorFinal)((function () {
                                        var $130 = Data_Tuple_T2.T2.create(v1.key);
                                        return function ($131) {
                                            return Data_Maybe.Just.create($130($131));
                                        };
                                    })())(Restaumatic_Form.queryWith(dictQuery)(strictness)(v1.subform));
                                };
                                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(Data_Maybe.Nothing.value);
                            });
                        });
                    }));
                });
            };
        }
    };
};
var queryOMapList = function (dictQuery) {
    return function (dictOrd) {
        return {
            queryWith: function (strictness) {
                return function (l) {
                    return Data_Functor.map(Restaumatic_Form_Final.functorFinal)((function () {
                        var $132 = Data_Map_Ordered.fromArray(dictOrd);
                        var $133 = Data_Functor.map(Data_Functor.functorArray)(Data_Tuple_T2.toTuple);
                        return function ($134) {
                            return $132($133($134));
                        };
                    })())(Restaumatic_Form.queryWith(queryOMapArrayList(dictQuery))(strictness)(l));
                };
            }
        };
    };
};
var queryNonEmptyArrayList = function (dictQuery) {
    return {
        queryWith: function (strictness) {
            return function (v) {
                return Restaumatic_Form_Final.makeFinalV(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Bifunctor.bimap(Data_Validation_Semigroup.bifunctorV)(Restaumatic_Form.tagErrors(v.name))(Control_Category.identity(Control_Category.categoryFn)))(Restaumatic_Form_Final.unFinalV(Restaumatic_Form.mapMaybeFinalUserVisible(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required))(Data_Array_NonEmpty.fromArray)(Restaumatic_Form.queryWith(dictQuery)(strictness)(v)))));
            };
        }
    };
};
var queryNewtypeList = function () {
    return function (dictQuery) {
        return {
            queryWith: function (strictness) {
                return function (l) {
                    return Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Newtype.wrap())(Restaumatic_Form.queryWith(dictQuery)(strictness)(l));
                };
            }
        };
    };
};
var queryItem = function (dictQuery) {
    return {
        queryWith: function (s) {
            return function (v) {
                return Restaumatic_Form.queryWith(dictQuery)(s)(v.subform);
            };
        }
    };
};
var queryArrayList = function (dictQuery) {
    return {
        queryWith: function (strictness) {
            return function (l) {
                return Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple_T2.proj2))(Restaumatic_Form.queryWith(queryOMapArrayList(dictQuery))(strictness)(l));
            };
        }
    };
};
var presentWhen = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(v1.presentWhen)(v));
    };
};
var newtypeLocalId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListItem = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeList = {
    Coercible0: function () {
        return undefined;
    }
};
var newItem = function (dictShow) {
    return function (v) {
        return function (key1) {
            return function __do() {
                var value = v.makeEmptyItem({
                    name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.name)([ Data_Show.show(dictShow)(key1) ])
                })();
                var v1 = Specular_FRP_Host.runHost(Control_Bind.bind(Specular_FRP_Host.bindHost)(Specular_Ref.readRef(Specular_FRP_Host.monadEffectHost)(v.init))(function (init) {
                    return Control_Bind.bind(Specular_FRP_Host.bindHost)(Specular_Ref.readRef(Specular_FRP_Host.monadEffectHost)(v.context))(function (ctx) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_FRP_Host.bindHost)(Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost)(v.addContext(ctx)(value)))(function () {
                            return Control_Bind.bind(Specular_FRP_Host.bindHost)(Specular_Ref["new"](Specular_FRP_Host.monadEffectHost)(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(true)))(function (presentWhen_) {
                                var item = {
                                    parent: v,
                                    key: key1,
                                    subform: value,
                                    presentWhen: presentWhen_,
                                    cleanup: Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit)
                                };
                                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_FRP_Host.bindHost)(Restaumatic_Form.defineForm(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost))(init(item)))(function () {
                                    return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)(item);
                                });
                            });
                        });
                    });
                }))();
                return {
                    key: v1.value0.key,
                    subform: v1.value0.subform,
                    parent: v1.value0.parent,
                    cleanup: v1.value1,
                    presentWhen: v1.value0.presentWhen
                };
            };
        };
    };
};
var moveItem = function (v) {
    return function (oldIndex) {
        return function (newIndex) {
            return Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.items))(Specular_Sortable_Utils.moveItem(oldIndex)(newIndex));
        };
    };
};
var mergeOMapArrayList = function (dictMerge) {
    return function (dictOrd) {
        return function (dictShow) {
            return {
                merge: function (xs) {
                    return function (v) {
                        return function __do() {
                            var oldItems = Specular_Ref.readRef(Effect_Class.monadEffectEffect)(v.items)();
                            Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(function (v1) {
                                return v1.cleanup;
                            })(oldItems)();
                            var newItems = Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray)(xs)(function (v1) {
                                return function __do() {
                                    var item = newItem(dictShow)(v)(v1.value0)();
                                    Restaumatic_Form.merge(dictMerge)(v1.value1)(subform(item))();
                                    return item;
                                };
                            })();
                            return Restaumatic_Form.writeRef(v.items)(newItems)();
                        };
                    };
                }
            };
        };
    };
};
var mergeOMapList = function (dictMerge) {
    return function (dictOrd) {
        return function (dictShow) {
            return {
                merge: function (xs) {
                    return function (l) {
                        return Restaumatic_Form.merge(mergeOMapArrayList(dictMerge)(dictOrd)(dictShow))(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple_T2.fromTuple)(Data_Map_Ordered.toArray(xs)))(l);
                    };
                }
            };
        };
    };
};
var mergeOMultiSetList = function (dictMerge) {
    return function (dictOrd) {
        return function (dictShow) {
            return {
                merge: function (xs) {
                    return function (l) {
                        return Restaumatic_Form.merge(mergeOMapArrayList(dictMerge)(dictOrd)(dictShow))(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple_T2.fromTuple)(Data_OrderedMultiSet.toOccurArray(xs)))(l);
                    };
                }
            };
        };
    };
};
var mergeNonEmptyArrayList = function (dictShow) {
    return function (dictMerge) {
        return {
            merge: (function () {
                var $135 = Restaumatic_Form.merge(dictMerge);
                return function ($136) {
                    return $135(Data_Array_NonEmpty.toArray($136));
                };
            })()
        };
    };
};
var mergeNewtypeList = function () {
    return function (dictMerge) {
        return {
            merge: function (xs) {
                return function (l) {
                    return Restaumatic_Form.merge(dictMerge)(Data_Newtype.unwrap()(xs))(l);
                };
            }
        };
    };
};
var mergeItem = function (dictMerge) {
    return {
        merge: function (x) {
            return function (v) {
                return Restaumatic_Form.merge(dictMerge)(x)(v.subform);
            };
        }
    };
};
var mergeArrayList = function (dictShow) {
    return function (dictMerge) {
        return {
            merge: function (xs) {
                return function (v) {
                    return function __do() {
                        var oldItems = Specular_Ref.read(Effect_Class.monadEffectEffect)(v.items)();
                        Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(function (v1) {
                            return v1.cleanup;
                        })(oldItems)();
                        var newItems = Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray)(xs)(function (x) {
                            return function __do() {
                                var k = v.generateId();
                                var item = newItem(dictShow)(v)(k)();
                                Restaumatic_Form.merge(dictMerge)(x)(subform(item))();
                                return item;
                            };
                        })();
                        return Specular_Ref.write(Effect_Class.monadEffectEffect)(v.items)(newItems)();
                    };
                };
            }
        };
    };
};
var makeEmptyList = function (dictGenerateId) {
    return function (dictMakeEmpty) {
        return function (dictAddContext) {
            return {
                makeEmptyImpl: function (opts) {
                    return function __do() {
                        var items1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)([  ])();
                        var init = Specular_Ref["new"](Effect_Class.monadEffectEffect)(function (v) {
                            return Control_Applicative.pure(Restaumatic_Form.applicativeFormDefM)(Data_Unit.unit);
                        })();
                        var generateId = Restaumatic_Form_GenerateId.newIdGenerator(dictGenerateId)();
                        var context = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Monoid.mempty(Data_Vault.monoidVault))();
                        return {
                            name: opts.name,
                            items: items1,
                            init: init,
                            makeEmptyItem: Restaumatic_Form.makeEmptyImpl(dictMakeEmpty),
                            generateId: generateId,
                            addContext: Restaumatic_Form.addContext(dictAddContext),
                            context: context
                        };
                    };
                }
            };
        };
    };
};
var listItem$prime = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(v1.init)(v));
    };
};
var listItem = function (v) {
    return listItem$prime(function ($137) {
        return v(subform($137));
    });
};
var key = function (v) {
    return v.key;
};
var items = function (v) {
    return Specular_Ref.value(v.items);
};
var numItems = /* #__PURE__ */ (function () {
    var $138 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Array.length);
    return function ($139) {
        return $138(items($139));
    };
})();
var hasFieldItem = function (dictHasField) {
    return {
        getField: function (label) {
            return function (v) {
                return Data_Record.getField(dictHasField)(label)(v.subform);
            };
        }
    };
};
var generateLocalId = {
    newIdGenerator: function __do() {
        var next = Effect_Ref["new"](0)();
        return Data_Functor.map(Effect.functorEffect)(LocalId)(Effect_Ref.modify(function (v) {
            return Data_Numeric.add(Data_Numeric.additiveInt)(v)(1);
        })(next));
    }
};
var eqLocalId = Data_Eq.eqInt;
var encodeLocalId = Foreign_Generic_Class.intEncode;
var dumpStateList = function (dictEncodeWithOptions) {
    return function (dictDumpState) {
        return {
            dumpState: function (v) {
                return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.items))(function (items1) {
                    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                        reflectSymbol: function () {
                            return "subform";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })(dictEncodeWithOptions))))))))(Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordSingle({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })()(Specular_FRP_Base.functorDynamic)()())({
                        items: Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray)(items1)(function (v1) {
                            return Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordCons({
                                reflectSymbol: function () {
                                    return "key";
                                }
                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                reflectSymbol: function () {
                                    return "subform";
                                }
                            })()(Specular_FRP_Base.functorDynamic)()())()())({
                                key: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(v1.key),
                                subform: Restaumatic_Form.dumpState(dictDumpState)(v1.subform)
                            });
                        })
                    }));
                });
            }
        };
    };
};
var displayedItems = function (v) {
    return Specular_Ref.value(v.items);
};
var displayList = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (l) {
            return function (renderItem) {
                return Specular_FRP_List.dynamicListWithIndex_(dictMonadFRP)(dictMonadReplace)(displayedItems(l))(function (ix) {
                    return function (ditem) {
                        return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(ditem)(renderItem(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(ix)));
                    };
                });
            };
        };
    };
};
var deleteItem = function (dictEq) {
    return function (v) {
        return function __do() {
            Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.parent.items)(function (a) {
                return Data_Maybe.fromMaybe(a)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.findIndex(function (v2) {
                    return Data_Eq.eq(dictEq)(v2.key)(v.key);
                })(a))(function (index) {
                    return Data_Array.deleteAt(index)(a);
                }));
            })();
            return v.cleanup();
        };
    };
};
var deleteItemCb = function (dictEq) {
    return function () {
        return function (item) {
            return deleteItem(dictEq)(item);
        };
    };
};
var addItem = function (dictShow) {
    return function (v) {
        return function (k) {
            return function __do() {
                var item = newItem(dictShow)(v)(k)();
                Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.items)(function (v1) {
                    return Data_Array.snoc(v1)(item);
                })();
                return item;
            };
        };
    };
};
var pushItem = function (dictShow) {
    return function (v) {
        return function __do() {
            var k = v.generateId();
            return addItem(dictShow)(v)(k)();
        };
    };
};
var pushItemCb = function (dictShow) {
    return function (l) {
        return Data_Functor["void"](Effect.functorEffect)(pushItem(dictShow)(l));
    };
};
var addContextList = function (dictAddContext) {
    return {
        addContext: function (ctx) {
            return function (v) {
                return function __do() {
                    Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.context))(function (v1) {
                        return Data_Semigroup.append(Data_Vault.semigroupVault)(ctx)(v1);
                    })();
                    var items1 = Specular_Ref.readRef(Effect_Class.monadEffectEffect)(v.items)();
                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(items1)(function (item) {
                        return Restaumatic_Form.addContext(dictAddContext)(ctx)(subform(item));
                    })();
                };
            };
        }
    };
};
export {
    LocalId,
    List,
    ListItem,
    key,
    subform,
    listItem,
    listItem$prime,
    presentWhen,
    numItems,
    items,
    newItem,
    pushItem,
    addItem,
    pushItemCb,
    deleteItem,
    deleteItemCb,
    displayedItems,
    moveItem,
    displayList,
    newtypeLocalId,
    eqLocalId,
    showLocalId,
    encodeLocalId,
    generateLocalId,
    newtypeList,
    hasFieldIdList,
    newtypeListItem,
    hasFieldItem,
    queryItem,
    mergeItem,
    hasErrorsListItem,
    isTextFieldListItem,
    hasFieldIdListItem,
    makeEmptyList,
    mergeOMapList,
    mergeOMultiSetList,
    mergeOMapArrayList,
    mergeArrayList,
    mergeNonEmptyArrayList,
    mergeNewtypeList,
    queryOMapArrayList,
    queryArrayList,
    queryOMapList,
    queryNonEmptyArrayList,
    queryNewtypeList,
    addContextList,
    dumpStateList
};
//# sourceMappingURL=index.js.map
